import getApiClient from '../../../plugins/api'
const validator = require('cpf-cnpj-validator');

export default {
    loadOrders() {
        const self = this;
        const api = getApiClient(self.$store);

        self.orders = []
        self.$store.commit('startLoading')

        return api.get(`/orders`)
            .then((result) => {
                self.orders = result.data["hydra:member"]
            })
            .catch((error) => {})
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    openCancelModal() {
        const self = this
        if (self.orderDetails) {
            self.showOrderModal = false
            self.showCancelModal = true
        }
    },

    openPayPixModal() {
        const self = this
        if (self.orderDetails) {
            self.showOrderModal = false
            self.showPayPixModal = true
        }
    },

    openPayCreditCardModal() {
        const self = this
        if (self.orderDetails) {
            self.loadAvailableInstallments().then(() => {
                self.showOrderModal = false
                self.showPayCreditCardModal = true
            })
        }
    },

    cancelOrder(orderId) {
        const self = this;
        const api = getApiClient(self.$store);

        self.cancelOrderError = false

        self.$store.commit('startLoading')
        self.blockAction = true

        api.patch(`orders/cancel/${orderId}`, {}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then((result) => {
                const data = result.data

                if (data.cancelResult) {
                    self.cancelOrderSuccess = true
                    self.cancelOrderError = null
                } else {
                    throw 400
                }
            })
            .catch((error) => {
                self.cancelOrderError = 'Erro ao cancelar o seu pedido'
            })
            .finally(() => {
                self.$store.commit('stopLoading')
                self.blockAction = false
            })
    },

    formattedBankDisplay(bank) {
        return `${bank.label} (${bank.code})`
    },

    setRefundFormBankLabel(bank) {
        this.refundFormData.bankLabel = bank.display
    },

    validateBankAccountData() {
        const self = this;
        const requiredFields = [
            'bank',
            'agency',
            'account',
            'name',
            'document'
        ];

        let isValid = true;
        for (const key in requiredFields) {
            const value = requiredFields[key]
            if (! self.refundFormData[value]) {
                isValid = false
            }
        }

        return isValid;
    },

    validateCpf() {
        const self = this
        return validator.cpf.isValid(self.refundFormData.document, false)
    },

    completeCancelAction() {
        const self = this

        self.closeModals()
        self.loadOrders().then(() => {
            self.cancelOrderSuccess = null
            self.cancelOrderError = null
        })
    },

    closeModals() {
        this.showOrderModal = false
        this.showCancelModal = false
        this.showPayPixModal = false
        this.showPayCreditCardModal = false
        this.showTermsModal = false
        this.installments = null
        this.availableInstallments = []
    },

    goToPayment() {
        const self = this,
            api = getApiClient(self.$store)

        this.$store.commit('startLoading')

        let installmentSelected = (this.installments - 1);

        return api.patch(
            `/transaction/${this.orderDetails.transaction.replace(/[^0-9]/g, '')}/create_payment_link`,
            {
                "amount": String(this.availableInstallments[installmentSelected].total),
                "installments": this.availableInstallments[installmentSelected].value,
                "recebeAquiLink": '-', // Just to force entity update
            },
            {
                headers: {
                    'Content-Type': 'application/merge-patch+json'
                }
            })
            .then(result => {
                if (!result.data) {
                    console.error('An error has occurred.');
                    return;
                }

                window.open(result.data.recebeAquiLink);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                self.$store.commit('stopLoading');
            });
    },

    setInstallments: function(installment) {
        this.installments = installment
    },

    loadAvailableInstallments() {
        const self = this,
            api = getApiClient(self.$store)

        self.$store.commit('startLoading')

        return api.get(`cart/calculate_installments?price=${self.orderDetails.amountWithoutTaxes}`)
            .then(result => {
                for (let installmentOption in result.data.installments) {
                    const installment = result.data.installments[installmentOption],
                        installmentAmount = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(installment.installment_amount),
                        totalAmount = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(installment.amount),
                        installmentObj = {
                            label: `${installment.installment}x de ${installmentAmount}`,
                            value: installment.installment,
                            description: `Total de ${totalAmount}`,
                            total: installment.amount
                        }

                    if (! self.installments) {
                        self.installments = installmentOption
                    }

                    self.availableInstallments.push(installmentObj)
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    inArray(needle, haystack) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(typeof haystack[i] == 'object') {
                if(arrayCompare(haystack[i], needle)) return true;
            } else {
                if(haystack[i] == needle) return true;
            }
        }
        return false;
    },

    requestPaymentSupport: function() {
        const amount = new Intl
            .NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
            .format(this.orderDetails.amount)

        let message

        if (this.orderDetails.cart.paymentType === 1) {
            message = encodeURIComponent(`Tentei realizar o pagamento do pedido ${this.orderDetails.id} em ${this.orderDetails.cart.installments} vezes, no valor total de ${amount}, poderia gerar um link para pagamento, no site meu cartão não está sendo aprovado.`)
        } else {
            message = encodeURIComponent(`Tentei realizar o pagamento do pedido ${this.orderDetails.id}, no valor total de ${amount} e não consegui, poderia gerar um link para pagamento?`)
        }

        const link = `https://api.whatsapp.com/send?phone=5511984269437&text=${message}`

        window.open(link)
    }
}
